import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import { dateFormatter, registryLinkFormatter } from '../../../utils/formatters';
import { REGISTRY_TYPE } from '../../../configs';
import { getRegisterData } from '../reducer';
import {
  loadRelationCarrierSzltList, loadRelationCarrierSzltListClear,
  loadRelationCarrierVehicleClear, loadRelationCarrierVehicleList,
} from '../actions';
import { getPaginationOpts, responseLogWithNotification } from '../../../utils/utils';
import Pagination from '../../../components/base/Pagination/Pagination';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import Switches from '../../../components/fields/Switches/Switches';
import RegistryPageModal from './RegistryPageModal';
import getDefaultSort from '../../../utils/getDefaultSort';

export default function CarrierMiniGrid(props) {
  const {
    setIsHistoryPopUp = () => {}, isVehicleRelationType = true, params = {},
  } = props;
  const [isRegistryModal, setIsRegistryModal] = useState(false);
  const dispatch = useDispatch();
  const {
    relationCarrierSzltList = [],
    relationCarrierVehicleListMeta = {},
    relationCarrierSzltListMeta = [],
    relationCarrierVehicleList = [],
    loadingRelationCarrierSzltList,
    loadingRelationCarrierVehicleList,
  } = useSelector(getRegisterData);
  const action = isVehicleRelationType ? loadRelationCarrierVehicleList : loadRelationCarrierSzltList;
  const currentList = isVehicleRelationType ? relationCarrierVehicleList : relationCarrierSzltList;
  const currentMeta = isVehicleRelationType ? relationCarrierVehicleListMeta : relationCarrierSzltListMeta;
  const loading = isVehicleRelationType ? loadingRelationCarrierVehicleList : loadingRelationCarrierSzltList;

  useEffect(() => {
    if (isVehicleRelationType) {
      dispatch(loadRelationCarrierVehicleClear());
      return;
    }
    dispatch(loadRelationCarrierSzltListClear());
  }, []);

  const carriersColumns = [
    {
      dataField: 'carrier',
      text: 'Номер записи',
      sortField: 'registry_id',
      formatter: item => registryLinkFormatter(item?.number, REGISTRY_TYPE.CARRIER, { registry_id: item?.id }),
    },
    {
      dataField: 'carrier',
      headerClassName: 'effective-date',
      text: 'Дата начала срока действия права',
      sortField: 'effective',
      formatter: (_, item) => dateFormatter(item?.effective_date),
    },
    {
      dataField: 'carrier',
      sortField: 'expiration_date',
      text: 'Дата окончания срока действия права',
      formatter: (_, item) => dateFormatter(item?.expiration_date),
    },
    {
      dataField: 'vehicle',
      sortField: 'is_active',
      text: 'Статус связи',
      formatter: (_, item) => (item?.is_active ? 'Действующая' : 'Недействующая'),
    },
  ];
  const {
    getValues, control, watch,
  } = useForm({});

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(currentMeta, opts);

    const requestData = {
      ...paginationOpts,
      filter: {
        ...params,
        ...filterData,
      },
      sort,
    };

    const p1 = dispatch(action(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [sort, setSort] = useState(getDefaultSort(carriersColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    dispatch(action({ filter: { ...params } })).catch(responseLogWithNotification);
  }, []);

  return (
    <div className="afc-data">
      <div className="afc-wrapper">
        <div className="afc-header">
          <div className="afc-header-text">
            Связи с реестром перевозчиков
          </div>
          <FieldDTO
            type="text"
            control={control}
            component={Switches}
            dtoObject={{
              name: 'only_active',
              type: String,
              validators: [],
              labelKey: 'registry.isAvailable',
            }}
            variant="material"
          />
          <div className="table-control-button">
            <div
              className={classNames('link-text', { disabled: !currentList?.length })}
              onClick={currentList?.length && (() => setIsRegistryModal(true))}
            ><Icons
              customIcon
              icon="same-registry"
            />
            </div>
            <Icons
              customIcon
              className="history-icon"
              icon="history-relation"
              onClick={() => setIsHistoryPopUp('carrier')}
            />
          </div>
        </div>
        <div className="afc-body">
          <div className="grid-wrapper">
            <div className="custom-scroll-theme">
              <Grid
                data={currentList}
                changeSort={changeSort}
                sort={sort}
                columns={carriersColumns}
                loading={loading}
              />
            </div>
            <Pagination
              meta={currentMeta}
              list={currentList}
              handleChangeMeta={loadData}
            />
          </div>
        </div>
      </div>
      {
        isRegistryModal ? (
          <RegistryPageModal
            type="carrier"
            customFilter={{
              numbers: (currentList || []).map(i => i?.carrier.number),
            }}
            onClose={() => setIsRegistryModal(false)}
          />
        ) : null
      }
    </div>
  );
}
